module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading/loading.component.css
// module id = ./src/app/components/loading/loading.component.css
// module chunks = main